import React from "react";
import Skeleton from "react-loading-skeleton";

const MobileBottomSheetLoader = () => {
  return (
    <div className="bottomSheet_chip">
      <Skeleton
        width={100}
        height={25}
        count={1}
        style={{
          "--base-color": "#ccc",
          "--highlight-color": "#f5f5f5",
        }}
        inline
      />
    </div>
  );
};

export default MobileBottomSheetLoader;
